import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { PATH_PRODUCT_LOGIN, PATH_TRIAL_UPGRADE } from '~/common/utils/consts';
import { gtm, clickCtaEvent } from '~/common/utils/tracking.js';

import Button from '../CommonButton';

import styles from './true-solo-trial-conversion.css';

@inject('convertToPaidStore', 'modalStore', 'progressStore')
@observer
export default class TrueSoloTrialConversionModal extends Component {
    handleModalClose = () => {
        const { modalStore } = this.props;
        modalStore.setModalOptions({ isModalOpen: false });
    }

    renderContent = () => {
        const { convertToPaidStore: { isTrialPassiveExpired, trialUsersAndExtensions } } = this.props;
        if (isTrialPassiveExpired) {
            return {
                title: 'True Solo allows 1 user/1 extension',
                content: 'Please select a different plan, or contact us at (800) 820-8210 to remove additional users/extensions from your account.'
            };
        }

        if (trialUsersAndExtensions.extensions > 2 && !trialUsersAndExtensions.callRecording) {
            return {
                title: 'Please note',
                content: 'True Solo allows 1 user/1 extension. Please select another plan or remove additional users/extensions from your account.'
            };
        }

        if (trialUsersAndExtensions.extensions > 2 && trialUsersAndExtensions.callRecording) {
            return {
                title: 'Please note',
                content: 'True Solo allows 1 user/1 extension and does not include call recording. Please select another plan or remove additional users/extensions and disable the call recording feature from your account.'
            };
        }

        if (trialUsersAndExtensions.extensions < 3 && trialUsersAndExtensions.callRecording) {
            return {
                title: 'Please note',
                content: 'True Solo does not include call recording. If you proceed with your purchase the call recording feature will be disabled.'
            };
        }

        return {
            title: 'You have too many users/extensions',
            content: 'True Solo allows 1 user/1 extension. Please select another plan or remove additional users/extensions from your account.'
        };
    }

    render() {
        const { convertToPaidStore: { isTrialPassiveExpired, trialUsersAndExtensions, isUserConvertingToPaid }, modalStore: { callback }, progressStore } = this.props;
        const { title, content } = this.renderContent();
        return (
            <div className={styles.modal}>
                <h1 className={styles.header}>
                    {title}
                </h1>

                <p className={styles.content}>
                    {content}
                </p>

                {isTrialPassiveExpired ?
                    <Button
                        onClick={() => {
                            gtm(clickCtaEvent('Select another plan', '', 'True Solo Trial conversion modal'));
                            this.handleModalClose();
                        }}
                    >
                        Select another plan
                    </Button>
                    : <div className={styles['cta-grp']}>
                        <Button
                            onClick={() => {
                                gtm(clickCtaEvent('Select another plan', '', 'True Solo Trial conversion modal'));
                                this.handleModalClose();
                            }}
                        >
                            Select another plan
                        </Button>
                        {trialUsersAndExtensions.extensions < 3 && trialUsersAndExtensions.callRecording ?
                            <Button
                                onClick={() => {
                                    callback();
                                    this.handleModalClose();
                                }}
                                tertiary
                                to={isUserConvertingToPaid ? PATH_TRIAL_UPGRADE : progressStore.nextStepFromPlans}
                            >
                                Proceed to checkout
                            </Button>
                            :
                            <Button
                                href={PATH_PRODUCT_LOGIN}
                                onClick={() => {
                                    gtm(clickCtaEvent('Access my account', PATH_PRODUCT_LOGIN, 'True Solo Trial conversion modal'));
                                    this.handleModalClose();
                                }}
                                target='_blank'
                                tertiary
                            >
                                Access my account
                            </Button>
                        }
                    </div>
                }
            </div>
        );
    }
}
